let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gnYru")).then(() => parcelRequire('8oIJl'));